import React, { useState, useEffect } from 'react';
import style from './FoodHighlightCard.module.css';
import noImg from '../../images/common/img_no_diet_02.png';

const FoodHighlightCard = ({ rank, image, title, info, date, isWarning, warningText }) => {

    const [imgError, setImgError] = useState(false);

    // 이미지 URL이 변경되면 에러 상태 초기화
    useEffect(() => {
        setImgError(false);
    }, [image])

    // 이미지 URL이 null 이거나 에러면 no-img 노출
    const isNoImage = !image || imgError;

    return (
        <div className={style.card}>
            <div className={style.imgWrap}>
                {isNoImage ? (
                    <div className={style.imgPlaceholder}>
                        <img src={noImg} alt="" draggable={false} />
                    </div>
                ) : (
                    <img
                        src={image}
                        alt="식단 이미지"
                        draggable={false}
                        onError={() => setImgError(true)}
                    />
                )}
            </div>
            <div className={style.body}>
                <span className={style.rank} date-statue={isWarning && "warning"} >{rank}</span>
                <div className={style.bodyConBox}>
                    <strong className={style.title}>{title}</strong>
                    <span className={style.info}>{info}</span>
                    <div className={style.bottom}>
                        <span className={style.date}>{date}</span>
                        {isWarning && warningText ? (
                            <span className={style.warning}>{warningText}</span>
                        ) : (
                            <span className={style.good}>우수</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FoodHighlightCard;